// collection-faq-meta-fields js start
document.querySelectorAll('.collection-faqmeta-fields .faq-question').forEach(item => {
    item.addEventListener('click', () => {
        let answer = item.nextElementSibling;
        item.classList.toggle('active');
        answer.classList.toggle('show');
    });
});
// collection-faq-meta-fields js end



// product-template js start
document.addEventListener("DOMContentLoaded", function () {

    function toggleMessages() {
        var goldMessage = document.querySelector('.gold-message');
        var promiseSection = document.querySelector('.promise-product-page');
        var buttonText = document.querySelector('.product-form__submit .txt');

        if (!buttonText) return;

        var text = buttonText.innerText.trim().toLowerCase();

        // Hide both first
        if (goldMessage) goldMessage.style.display = "none";
        if (promiseSection) promiseSection.style.display = "none";

        // Show based on button text
        if (text === "made to order") {
            if (goldMessage) goldMessage.style.display = "block";
        } else if (text === "add to cart") {
            if (promiseSection) promiseSection.style.display = "block";
        }
    }

    // Run on page load
    toggleMessages();

    // Watch for variant or button changes
    var targetNode = document.querySelector('.template-product');

    if (targetNode) {
        var observer = new MutationObserver(function () {
            toggleMessages();
        });

        observer.observe(targetNode, {
            childList: true,
            subtree: true,
            characterData: true
        });
    }

});
// product-template js end




// product-template js start
document.addEventListener("DOMContentLoaded", function() {

    var goldMessage = document.querySelector('.gold-message');
    var button = document.querySelector('.product-form__submit .txt');

    function toggleGoldMessage() {
        if (!button || !goldMessage) return;

        var text = button.innerText.trim().toLowerCase();

        if (text === "made to order") {
            goldMessage.style.display = "block";
        } else {
            goldMessage.style.display = "none";
        }
    }

    // Run on page load
    toggleGoldMessage();

    // Watch for button text change (variant change)
    var observer = new MutationObserver(function() {
        toggleGoldMessage();
    });

    if (button) {
        observer.observe(button, {
            childList: true,
            subtree: true,
            characterData: true
        });
    }

});

// product-template js end



// product-template offer js start
document.querySelectorAll('.offers-box').forEach(section => {

  /* =============================
     ACCORDION TOGGLE
  ============================== */
  section.querySelectorAll('.offer-top').forEach(top => {
    top.addEventListener('click', () => {

      const item = top.closest('.offer-item');
      const bottom = item.querySelector('.offer-bottom');
      const arrow = item.querySelector('.arrow');

      // Close others inside same section only
      section.querySelectorAll('.offer-bottom').forEach(el => {
        if (el !== bottom) {
          el.style.display = 'none';
          el.closest('.offer-item')
            .querySelector('.arrow')
            .style.transform = 'rotate(0deg)';
        }
      });

      // Toggle current
      const isOpen = bottom.style.display === 'flex';

      bottom.style.display = isOpen ? 'none' : 'flex';
      arrow.style.transform = isOpen ? 'rotate(0deg)' : 'rotate(180deg)';
    });
  });


  /* =============================
     COPY COUPON
  ============================== */
  section.querySelectorAll('.copy-btn').forEach(btn => {
    btn.addEventListener('click', e => {
      e.stopPropagation();
      const code = btn.dataset.code;

      navigator.clipboard.writeText(code);

      btn.innerText = 'Copied';
      setTimeout(() => btn.innerText = 'Copy Code', 1500);
    });
  });


  /* =============================
     MORE OFFERS TOGGLE
  ============================== */
  const moreOffers = section.querySelector('.more-offers');
  const toggleBtn = section.querySelector('.toggle-btn');

  if (moreOffers && toggleBtn) {

    const offerItems = moreOffers.querySelectorAll('.offer-item');
    const offerCount = offerItems.length;

    // Hide initially
    moreOffers.style.display = 'none';

    // Hide button if no offers
    if (offerCount === 0) {
      toggleBtn.style.display = 'none';
      return;
    }

    function updateButtonText(isOpen) {
      if (isOpen) {
        toggleBtn.innerText = 'Close';
      } else {
        toggleBtn.innerText =
          offerCount === 1
            ? `+${offerCount} More Offer`
            : `+${offerCount} More Offers`;
      }
    }

    updateButtonText(false);

    toggleBtn.addEventListener('click', () => {
      const isOpen = moreOffers.style.display === 'block';

      moreOffers.style.display = isOpen ? 'none' : 'block';
      updateButtonText(!isOpen);
    });
  }

});
// product-template offer js end




// product-template sharebutton js start
document.addEventListener("DOMContentLoaded", function () {
  const shareBtn = document.getElementById("shareBtn");
  if (!shareBtn) return;
  shareBtn.addEventListener("click", async () => {
    const shareData = {
      title: "{{ product.title }}",
      text: "Check out this product",
      url: window.location.href
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err) {
        console.log("Share cancelled");
      }
    } else {
      // Fallback for desktop
      navigator.clipboard.writeText(window.location.href);
      alert("Link copied to clipboard!");
    }

  });
});
// product-template sharebutton js end



// product-template sharebutton js start

document.addEventListener("DOMContentLoaded", function () {

  function initWrapper(wrapper) {

    const textEl = wrapper.querySelector('.product-form__submit[name="add"] .txt');
    if (!textEl) return;

    function updateClass() {
      const text = textEl.textContent.trim().toLowerCase();

      if (text === "made to order") {
        wrapper.classList.add("hide-buy-now");
      } else {
        wrapper.classList.remove("hide-buy-now");
      }
    }

    // First run
    updateClass();

    // 👇 Observe text change (IMPORTANT)
    const observer = new MutationObserver(updateClass);

    observer.observe(textEl, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  // 👇 Apply on all wrappers
  document.querySelectorAll('.productaddtocart-buyitnowbutton').forEach(wrapper => {
    initWrapper(wrapper);
  });

});


document.addEventListener("DOMContentLoaded", function () {

  function updateOrderType(wrapper) {
    const input = wrapper.querySelector('.order-type-input');
    if (!input) return;

    if (wrapper.classList.contains('hide-buy-now')) {
      input.value = "Made To Order";
    } else {
      input.value = "";
    }
  }

  document.querySelectorAll('.productaddtocart-buyitnowbutton').forEach(wrapper => {

    // First run
    updateOrderType(wrapper);

    // 👇 Observe class change
    const observer = new MutationObserver(() => {
      updateOrderType(wrapper);
    });

    observer.observe(wrapper, {
      attributes: true,
      attributeFilter: ['class']
    });

  });

});

// product-template sharebutton js end




// product-template appointment_popup js start
document.addEventListener('DOMContentLoaded', function () {
  const openBtns = document.querySelectorAll('.book-appointment-btn');
  const modals = document.querySelectorAll('.appointmentModal');

  openBtns.forEach((btn, index) => {
    const modal = modals[index];
    const closeBtn = modal.querySelector('.appointment-close');

    btn.addEventListener('click', () => {
      modal.style.display = 'flex';
    });

    closeBtn.addEventListener('click', () => {
      modal.style.display = 'none';
    });

    window.addEventListener('click', (e) => {
      if (e.target === modal) {
        modal.style.display = 'none';
      }
    });
  });
});
// product-template appointment_popup js end



// luxury-silver-gold js start
document.addEventListener("DOMContentLoaded", function () {

  const toggleSection = document.querySelectorAll(".lux-toggle");

  toggleSection.forEach(function(wrapper) {

    const items = wrapper.querySelectorAll(".lux-toggle-item");

    items.forEach(function(item) {

      item.addEventListener("click", function() {

        // Remove active class from all
        items.forEach(function(el) {
          el.classList.remove("is-active");
        });

        // Add active class to clicked item
        this.classList.add("is-active");

        // If you want to redirect to collection link
        const url = this.getAttribute("data-url");
        if (url) {
          window.location.href = url;
        }

      });

    });

  });

});
// luxury-silver-gold js end


// product-template product-tab-jewellery-details js start
  const tabButtons = document.querySelectorAll('.tab-section .tab-button');
  const tabContents = document.querySelectorAll('.tab-section .tab-content');

  tabButtons.forEach((button) => {
    button.addEventListener('click', () => {
      tabButtons.forEach((btn) => btn.classList.remove('active'));
      tabContents.forEach((tab) => tab.classList.remove('active'));

      button.classList.add('active');
      document.getElementById(button.dataset.tab).classList.add('active');
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (document.body.classList.contains('template-product')) {
      const priceSection = document.querySelector('#price-breakdown-table');
      const priceButton = document.querySelector('.tab-button[data-tab="price"]');

      // Hide price tab if there's no content
      if (priceSection && priceButton && priceSection.innerText.trim() === '') {
        priceButton.style.display = 'none';
      }

      // Activate the first visible tab and its corresponding content
      const tabButtons = document.querySelectorAll('.tab-button');
      const tabContents = document.querySelectorAll('.tab-content');

      let activated = false;
      tabButtons.forEach((button) => {
        const tabName = button.getAttribute('data-tab');
        const content = document.getElementById(tabName);

        if (!activated && button.style.display !== 'none') {
          button.classList.add('active');
          if (content) content.classList.add('active');
          activated = true;
        } else {
          button.classList.remove('active');
          if (content) content.classList.remove('active');
        }
      });

      // Optional: Add click event listener to handle tab switching
      tabButtons.forEach((button) => {
        button.addEventListener('click', () => {
          tabButtons.forEach((btn) => btn.classList.remove('active'));
          tabContents.forEach((content) => content.classList.remove('active'));

          const target = button.getAttribute('data-tab');
          button.classList.add('active');
          document.getElementById(target)?.classList.add('active');
        });
      });
    }
  });
// product-template product-tab-jewellery-details js end




// product-template js start
document.addEventListener("DOMContentLoaded", function() {

    const selects = document.querySelectorAll('.single-option-selector');

    selects.forEach(function(select){

        const options = select.querySelectorAll('option');

        options.forEach(function(option){

            const qty = parseInt(option.getAttribute("data-inventory-quantity")) || 0;
            const policy = option.getAttribute("data-inventory-policy");

            let stockText = "";

            if ((qty === 0 || qty === -1) && policy === "continue") {
                stockText = " - Made to Order";
            } 
            else if (qty >= 1) {
                stockText = " - In Stock";
            } 
            else {
                stockText = " - Out of Stock";
            }

            // Original size value
            const sizeValue = option.value;

            // Update option text
            option.textContent = sizeValue + stockText;

        });

    });

});
// product-template js end






document.addEventListener("DOMContentLoaded", function(){

  const variantInputs = document.querySelectorAll(
    ".template-product variant-selects .product-form__input:not(.swatch)"
  );

  if(variantInputs.length == 1){
    document.querySelector(".template-product").classList.add("variant-one");
  }

  if(variantInputs.length >= 2){
    document.querySelector(".template-product").classList.add("variant-two");
  }

});





// mobile-menu-section slider js start
$(document).ready(function(){
  $('.mobile-menu .custom-slick-slider').slick({
    slidesToShow: 1.5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    dots: true,
    infinite: false
  });
});
// mobile-menu-section slider js end



// product-template see-similar-products slider js start

document.addEventListener("DOMContentLoaded", function() {

  // Open popup
  const toggleBtn = document.querySelector(".see-similar-toggle");
  const popup = document.querySelector(".see-similar-container");

  if (toggleBtn && popup) {
    toggleBtn.addEventListener("click", function() {
      popup.classList.add("active");
      document.body.classList.add("overflow-hidden"); // optional (background scroll band)
    });
  }

  // Close popup (cross button)
  const closeBtn = document.querySelector(".see-similar-remove button");

  if (closeBtn) {
    closeBtn.addEventListener("click", function() {
      popup.classList.remove("active");
      document.body.classList.remove("overflow-hidden");
    });
  }

  // Optional: click outside close
  popup.addEventListener("click", function(e) {
    if (e.target === popup) {
      popup.classList.remove("active");
      document.body.classList.remove("overflow-hidden");
    }
  });

});


$('.similar-slider-products').slick({
  slidesToShow: 2.3,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  infinite: false,
  autoplay: window.innerWidth < 1024,
  autoplaySpeed: 8000,
  prevArrow: '<button type="button" class="slick-prev"><svg width="24" height="24"><path d="M15 6l-6 6 6 6" stroke="#1f5d7b" stroke-width="2" fill="none"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><svg width="24" height="24"><path d="M9 6l6 6-6 6" stroke="#1f5d7b" stroke-width="2" fill="none"/></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2.3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2.2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2.2
      }
    }
  ]
});


// product-template see-similar-products slider js end



// collection image slider js start


// function initProductSliders(){

//   document.querySelectorAll('.product-image-slider').forEach(function(slider){

//     if(slider.classList.contains("slider-loaded")) return;
//     slider.classList.add("slider-loaded");

//     const wrapper = slider.querySelector('.slider-wrapper');
//     const slides = slider.querySelectorAll('.slide-item');
//     const dotsContainer = slider.querySelector('.slider-dots');

//     if(!wrapper || slides.length === 0) return;

//     let index = 0;
//     let interval;

//     let startX = 0;
//     let endX = 0;

//     slides.forEach((slide,i)=>{

//       const dot = document.createElement('span');

//       if(i === 0){
//         dot.classList.add('active');
//         slide.classList.add('active');
//       }

//       dot.addEventListener('click',()=>{
//         index = i;
//         updateSlider();
//       });

//       if(dotsContainer){
//         dotsContainer.appendChild(dot);
//       }

//     });

//     const dots = slider.querySelectorAll('.slider-dots span');

//     function updateSlider(){

//       wrapper.style.transform = `translateX(-${index*100}%)`;

//       slides.forEach(slide => slide.classList.remove('active'));
//       dots.forEach(dot => dot.classList.remove('active'));

//       slides[index].classList.add('active');

//       if(dots[index]){
//         dots[index].classList.add('active');
//       }

//     }

//     function startSlider(){

//       interval = setInterval(()=>{

//         index++;

//         if(index >= slides.length){
//           index = 0;
//         }

//         updateSlider();

//       },2000);

//     }

//     function stopSlider(){
//       clearInterval(interval);
//     }

//     /* Desktop hover */
//     slider.addEventListener('mouseenter',startSlider);
//     slider.addEventListener('mouseleave',stopSlider);

//     /* Mobile swipe support */

//     slider.addEventListener("touchstart",function(e){
//       startX = e.touches[0].clientX;
//     });

//     slider.addEventListener("touchmove",function(e){
//       endX = e.touches[0].clientX;
//     });

//     slider.addEventListener("touchend",function(){

//       if(startX - endX > 50){
//         index++;
//         if(index >= slides.length) index = 0;
//       }

//       if(endX - startX > 50){
//         index--;
//         if(index < 0) index = slides.length - 1;
//       }

//       updateSlider();

//     });

//   });

// }

// /* First load */
// document.addEventListener("DOMContentLoaded",function(){
//   initProductSliders();
// });

// /* Shopify section reload */
// document.addEventListener("shopify:section:load",function(){
//   initProductSliders();
// });

// /* Infinite Scroll detection */

// const observer = new MutationObserver(function(mutations){

//   mutations.forEach(function(mutation){

//     if(mutation.addedNodes.length){
//       initProductSliders();
//     }

//   });

// });

// observer.observe(document.body,{
//   childList:true,
//   subtree:true
// });





function initProductSliders(){

  document.querySelectorAll('.product-image-slider').forEach(function(slider){

    if(slider.classList.contains("slider-loaded")) return;
    slider.classList.add("slider-loaded");

    const wrapper = slider.querySelector('.slider-wrapper');
    const slides = slider.querySelectorAll('.slide-item');
    const dotsContainer = slider.querySelector('.slider-dots');
    const link = slider.closest("a");

    if(!wrapper || slides.length === 0) return;

    let index = 0;
    let interval;

    let startX = 0;
    let endX = 0;

    /* Create dots */

    slides.forEach((slide,i)=>{

      const dot = document.createElement('span');

      if(i === 0){
        dot.classList.add('active');
        slide.classList.add('active');
      }

      dot.addEventListener('click',()=>{

        index = i;
        updateSlider();

      });

      if(dotsContainer){
        dotsContainer.appendChild(dot);
      }

    });

    const dots = slider.querySelectorAll('.slider-dots span');

    function updateSlider(){

      wrapper.style.transform = `translateX(-${index*100}%)`;

      slides.forEach(slide => slide.classList.remove('active'));
      dots.forEach(dot => dot.classList.remove('active'));

      slides[index].classList.add('active');

      if(dots[index]){
        dots[index].classList.add('active');
      }

    }

    /* Auto slider */

    function startSlider(){

      interval = setInterval(()=>{

        index++;

        if(index >= slides.length){
          index = 0;
        }

        updateSlider();

      },2000);

    }

    function stopSlider(){
      clearInterval(interval);
    }

    /* Desktop hover */

    slider.addEventListener('mouseenter',startSlider);
    slider.addEventListener('mouseleave',stopSlider);

    /* Mobile swipe */

    slider.addEventListener("touchstart",function(e){

      startX = e.touches[0].clientX;
      slider.classList.remove("swiping");

    });

    slider.addEventListener("touchmove",function(e){

      endX = e.touches[0].clientX;

      if(Math.abs(startX - endX) > 10){
        slider.classList.add("swiping");
      }

    });

    slider.addEventListener("touchend",function(){

      if(startX - endX > 50){

        index++;
        if(index >= slides.length) index = 0;

      }

      if(endX - startX > 50){

        index--;
        if(index < 0) index = slides.length - 1;

      }

      updateSlider();

    });

    /* Prevent click while swiping */

    if(link){

      link.addEventListener("click",function(e){

        if(slider.classList.contains("swiping")){

          e.preventDefault();
          e.stopPropagation();

        }

      });

    }

  });

}

/* First load */

document.addEventListener("DOMContentLoaded",function(){
  initProductSliders();
});

/* Shopify section reload */

document.addEventListener("shopify:section:load",function(){
  initProductSliders();
});

/* Infinite Scroll detection */

const observer = new MutationObserver(function(mutations){

  mutations.forEach(function(mutation){

    if(mutation.addedNodes.length){
      initProductSliders();
    }

  });

});

observer.observe(document.body,{
  childList:true,
  subtree:true
});



// collection image slider js end







// custom-featured-blog-slider js start
document.addEventListener("DOMContentLoaded", function () {
  const sliderCheck = setInterval(function () {
    if (window.jQuery && jQuery.fn.slick && $('.featured-slider').length) {
      clearInterval(sliderCheck);
      $('.featured-slider').slick({
        autoplay: true,
        autoplaySpeed: 3000,
        dots: true,
        arrows: true,
        infinite: true,
        fade: true,
        prevArrow: `
          <button class="slick-prev custom-arrow" aria-label="Previous">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"/>
            </svg>
          </button>`,
        nextArrow: `
          <button class="slick-next custom-arrow" aria-label="Next">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <path d="M9 18L15 12L9 6"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"/>
            </svg>
          </button>`
      });

    }
  }, 300);
});

$('.featured-slider').on('init reInit afterChange', function (event, slick, currentSlide) {

  var index = currentSlide ? currentSlide : 0;

  $('.hero-overlay').removeClass('animate');

  $('.slick-slide[data-slick-index="' + index + '"] .hero-overlay')
    .addClass('animate');
});
// custom-featured-blog-slider js end




// swiper-slider-3d js start
$(document).ready(function(){
    $('.swiper-slider-3d-coverflow .slick-slider-raj').slick({
      variableWidth: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: true,
      dots: false,
      centerMode: true,
      centerPadding: '0px',
      prevArrow: `
        <button type="button" class="slick-prev custom-circle-arrow">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="#111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>`,
      nextArrow: `
        <button type="button" class="slick-next custom-circle-arrow">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M9 6L15 12L9 18" stroke="#111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>`,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '90px'
          }
        }
      ]
    });
  });

  $('.swiper-slider-3d-coverflow .slick-slider-raj').on('init reInit afterChange', function(event, slick, currentSlide) {
  var i = currentSlide || 0;
  var total = slick.slideCount;
 
  $('.swiper-slider-3d-coverflow .slick-slider-raj  .slick-slide').removeClass('prev-slide next-slide');
 
  var prevIndex = (i - 1 + total) % total;
 
  var nextIndex = (i + 1) % total;
 
  $('.swiper-slider-3d-coverflow .slick-slider-raj .slick-slide[data-slick-index="' + prevIndex + '"]').addClass('prev-slide');
  $('.swiper-slider-3d-coverflow .slick-slider-raj .slick-slide[data-slick-index="' + nextIndex + '"]').addClass('next-slide');
});
// swiper-slider-3d js end




// about-column-slider js start
$(document).ready(function(){

  function initSlider() {
    if ($(window).width() < 1024) {
      
      if (!$('.four-column-slider .slider').hasClass('slick-initialized')) {
        $('.four-column-slider .slider').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          infinite: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      }

    } else {

      if ($('.four-column-slider .slider').hasClass('slick-initialized')) {
        $('.four-column-slider .slider').slick('unslick');
      }

    }
  }

  initSlider();

  $(window).on('resize', function(){
    initSlider();
  });

});
// about-column-slider js end



// collection-carousel js start
$('.collection-carousel').slick({
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  prevArrow: '<button class="slick-prev">&#10094;</button>',
  nextArrow: '<button class="slick-next">&#10095;</button>',

  responsive: [
    {
      breakpoint: 1024, // tablet
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 768, // mobile
      settings: {
        slidesToShow: 1.1,
        slidesToScroll: 1
      }
    }
  ]
});
// collection-carousel js end



// home-banner-slider js start
if (window.innerWidth > 767) {
  document.addEventListener('DOMContentLoaded', function() {
    const slider = document.querySelector('.banner-slider-wrapper');
    const leftArrow = document.querySelector('.banner-arrow.left');
    const rightArrow = document.querySelector('.banner-arrow.right');
    if (!slider) return;

    let isDown = false;
    let startX;
    let scrollLeft;
    let hasMoved = false;

    function disableSnap() {
      slider.style.scrollSnapType = 'none';
    }
    function enableSnap() {
      if (window.innerWidth <= 600) {
        slider.style.scrollSnapType = 'x mandatory';
      }
    }

    // Mouse events
    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      hasMoved = false;
      slider.classList.add('dragging');
      disableSnap();
      startX = e.pageX;
      scrollLeft = slider.scrollLeft;
    });
    document.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      hasMoved = true;
      const x = e.pageX;
      const dist = x - startX;
      slider.scrollLeft = scrollLeft - dist;
    });
    document.addEventListener('mouseup', () => {
      if (isDown) {
        isDown = false;
        slider.classList.remove('dragging');
        enableSnap();
        setTimeout(() => { hasMoved = false; }, 50);
      }
    });

    // Touch events
    let touchStartX = 0;
    let touchScrollLeft = 0;
    slider.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].pageX;
      touchScrollLeft = slider.scrollLeft;
      hasMoved = false;
      disableSnap();
    }, { passive: true });
    slider.addEventListener('touchmove', (e) => {
      hasMoved = true;
      const x = e.touches[0].pageX;
      const dist = touchStartX - x;
      slider.scrollLeft = touchScrollLeft + dist;
    }, { passive: true });
    slider.addEventListener('touchend', () => {
      enableSnap();
      setTimeout(() => { hasMoved = false; }, 50);
    }, { passive: true });

    slider.addEventListener('click', (e) => {
      if (hasMoved) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    }, true);

    const links = slider.querySelectorAll('a');
    links.forEach(link => {
      link.addEventListener('click', (e) => {
        if (hasMoved) {
          e.preventDefault();
          return false;
        }
      });
    });

    // === ARROW BUTTONS SCROLL ===
    leftArrow.addEventListener('click', () => {
      slider.scrollBy({ left: -slider.clientWidth / 1.2, behavior: 'smooth' });
    });
    rightArrow.addEventListener('click', () => {
      slider.scrollBy({ left: slider.clientWidth / 1.2, behavior: 'smooth' });
    });
  });
}
// home-banner-slider js end



// mc-valentine-card js start

// document.addEventListener("DOMContentLoaded", function () {

//   const modal = document.getElementById("val-modal");
//   const card = document.getElementById("val-card");
//   const clickableDivs = document.querySelectorAll(".clickableDiv");
//   const closeBtn = document.querySelector(".card-close-btn");
//   const form = document.getElementById("valentine-card");

//   /* -------------------------
//      OPEN MODAL (MULTIPLE SECTIONS)
//   ------------------------- */
//   clickableDivs.forEach(function(div) {
//     div.addEventListener("click", function () {
//       modal.style.display = "flex";
//       card.classList.add("open");
//     });
//   });

//   /* -------------------------
//      CLOSE MODAL
//   ------------------------- */
//   if (closeBtn) {
//     closeBtn.addEventListener("click", closeModal);
//   }

//   if (modal) {
//     modal.addEventListener("click", function (event) {
//       if (event.target === modal) {
//         closeModal();
//       }
//     });
//   }

//   function closeModal() {
//     if(modal) modal.style.display = "none";
//     if(card) card.classList.remove("open");
//   }

//   /* -------------------------
//      SAVE CARD DATA TO SHOPIFY CART
//   ------------------------- */
//   if (form) {
//     form.addEventListener("submit", function (event) {
//       event.preventDefault();

//       const formData = new FormData(form);

//       const updateData = new FormData();
//       updateData.append("attributes[To]", formData.get("to"));
//       updateData.append("attributes[Message]", formData.get("message"));
//       updateData.append("attributes[From]", formData.get("from"));

//       fetch("/cart/update.js", {
//         method: "POST",
//         body: updateData
//       })
//       .then(res => res.json())
//       .then(data => {

//         closeModal();

//         const saved = document.getElementById("after-val-saved");
//         if (saved) saved.style.display = "flex";

//       })
//       .catch(err => console.error("Cart update error:", err));
//     });
//   }

//   /* -------------------------
//      PREFILL FORM FROM CART
//   ------------------------- */
//   populateForm();

//   async function populateForm() {
//     try {

//       const res = await fetch("/cart.json");
//       const cart = await res.json();

//       if (cart.attributes && form) {

//         const toInput = form.querySelector('[name="to"]');
//         const messageInput = form.querySelector('[name="message"]');
//         const fromInput = form.querySelector('[name="from"]');

//         if (toInput) toInput.value = cart.attributes["To"] || "";
//         if (messageInput) messageInput.value = cart.attributes["Message"] || "";
//         if (fromInput) fromInput.value = cart.attributes["From"] || "";

//       }

//     } catch (err) {
//       console.error("Cart fetch error:", err);
//     }
//   }

// });

(function () {

  /* -------------------------
     MODAL OPEN (WORKS EVERYWHERE)
  ------------------------- */
  document.addEventListener("click", function (e) {

    // OPEN MODAL
    const openBtn = e.target.closest(".clickableDiv");
    if (openBtn) {
      const modal = document.getElementById("val-modal");
      const card = document.getElementById("val-card");

      if (modal && card) {
        modal.style.display = "flex";
        card.classList.add("open");
      }
    }

    // CLOSE BUTTON
    if (e.target.closest(".card-close-btn")) {
      closeModal();
    }

    // CLICK OUTSIDE MODAL
    const modal = document.getElementById("val-modal");
    if (modal && e.target === modal) {
      closeModal();
    }

  });

  function closeModal() {
    const modal = document.getElementById("val-modal");
    const card = document.getElementById("val-card");

    if (modal) modal.style.display = "none";
    if (card) card.classList.remove("open");
  }

  /* -------------------------
     FORM SUBMIT (SAVE TO CART)
  ------------------------- */
  document.addEventListener("submit", function (event) {

    const form = event.target;

    if (form && form.id === "valentine-card") {
      event.preventDefault();

      const formData = new FormData(form);

      const updateData = new FormData();
      updateData.append("attributes[To]", formData.get("to"));
      updateData.append("attributes[Message]", formData.get("message"));
      updateData.append("attributes[From]", formData.get("from"));

      fetch("/cart/update.js", {
        method: "POST",
        body: updateData
      })
      .then(res => res.json())
      .then(() => {

        closeModal();

        const saved = document.getElementById("after-val-saved");
        if (saved) saved.style.display = "flex";

      })
      .catch(err => console.error("Cart update error:", err));
    }

  });

  /* -------------------------
     PREFILL FORM FROM CART
  ------------------------- */
  async function populateForm() {
    try {

      const form = document.getElementById("valentine-card");
      if (!form) return;

      const res = await fetch("/cart.json");
      const cart = await res.json();

      if (cart.attributes) {

        const toInput = form.querySelector('[name="to"]');
        const messageInput = form.querySelector('[name="message"]');
        const fromInput = form.querySelector('[name="from"]');

        if (toInput) toInput.value = cart.attributes["To"] || "";
        if (messageInput) messageInput.value = cart.attributes["Message"] || "";
        if (fromInput) fromInput.value = cart.attributes["From"] || "";

      }

    } catch (err) {
      console.error("Cart fetch error:", err);
    }
  }

  /* -------------------------
     INITIAL LOAD
  ------------------------- */
  document.addEventListener("DOMContentLoaded", populateForm);

  /* -------------------------
     RE-RUN ON AJAX CART UPDATE
  ------------------------- */
  const observer = new MutationObserver(() => {
    populateForm();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();

// mc-valentine-card js end



// image-product-slider js start
$(document).ready(function(){
  $('.two-side-wrapper .productSlickSlider').slick({
    slidesToShow: 4.2,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"><svg fill="currentColor" viewBox="0 0 20 20"> <path d="M12.707 15.707a1 1 0 01-1.414 0L6 10.414a1 1 0 010-1.414l5.293-5.293a1 1 0 111.414 1.414L8.414 10l4.293 4.293a1 1 0 010 1.414z"></path> </svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg fill="currentColor" viewBox="0 0 20 20"> <path d="M7.293 4.293a1 1 0 011.414 0L14 9.586a1 1 0 010 1.414l-5.293 5.293a1 1 0 11-1.414-1.414L11.586 10 7.293 5.707a1 1 0 010-1.414z"></path> </svg></button>',
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 4.2 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 3 }
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 3 }
      }
    ]
  });
});
// image-product-slider js end





// celebration-section js start

(function(){

  function celebrationSlider(){

    var $slider = $('.celebration-slick');

    // Tablet + Mobile → Slider ON
    if(window.innerWidth <= 1024){

      if(!$slider.hasClass('slick-initialized')){

        $slider.slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
          dots: false,

          autoplay: true,
          autoplaySpeed: 5000,

          pauseOnHover: false,
          pauseOnFocus: false,

          speed: 600,

          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                dots: true,
              }
            }
          ]

        });

      }

    } 
    // Desktop → Slider OFF → Grid Layout
    else {

      if($slider.hasClass('slick-initialized')){
        $slider.slick('unslick');
      }

    }

  }

  // First Load
  document.addEventListener("DOMContentLoaded", function(){
    celebrationSlider();
  });

  // Resize
  window.addEventListener("resize", function(){
    celebrationSlider();
  });

})();

// celebration-section js end



// custom-our-stores js start
$(document).ready(function () {
  var $slider = $('.our-stores-slider');

  $slider.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    dots: false,
    swipe: true,
    touchMove: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.2,
        },
      },
    ],
  });

  $('.store-slider-btn.prev').on('click', function () {
    $slider.slick('slickPrev');
  });

  $('.store-slider-btn.next').on('click', function () {
    $slider.slick('slickNext');
  });
});
// custom-our-stores js end



// what-slide-image js start
$(".image-container").slick({
  slidesToShow: 4,
  infinite: true,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  prevArrow: '<button type="button" class="slick-prev testi-left-arro"><span style="font-size: 60px;">&#8249;</span></button>',
  nextArrow: '<button type="button" class="slick-next testi-right-arro"><span style="font-size: 60px;">&#8250;</span></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        prevArrow: '<button type="button" class="slick-prev testi-left-arro"><span style="font-size: 40px;">&#8249;</span></button>',
        nextArrow: '<button type="button" class="slick-next testi-right-arro"><span style="font-size: 40px;">&#8250;</span></button>',
      }
    },
    {
      breakpoint: 600, 
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
      }
    }
  ]
});
// what-slide-image js end



// dropdown-accordion js start
document.querySelector(".know-more-btn").addEventListener("click", function () {
  this.parentElement.classList.toggle("active");
});

document.querySelectorAll(".faq-question").forEach(button => {
  button.addEventListener("click", () => {
    const item = button.closest(".faq-item");

    document.querySelectorAll(".faq-item").forEach(faq => {
      if (faq !== item) faq.classList.remove("active");
    });

    item.classList.toggle("active");
  });
});
// dropdown-accordion js end




// blog-slider js start
// document.addEventListener('DOMContentLoaded', function() {
//   const track = document.querySelector('.blog-slider-track');
//   const slides = Array.from(document.querySelectorAll('.blog-slide'));
//   const nextButton = document.querySelector('.blog-slider-button.next');
//   const prevButton = document.querySelector('.blog-slider-button.prev');

//   let currentSlide = 0;
//   let slidesPerView = getSlidesPerView();

//   function getSlidesPerView() {
//     const width = window.innerWidth;
//     if (width >= 1024) return 4; // Desktop
//     if (width >= 768) return 2; // Tablet
//     return 2; // Mobile
//   }

//   function updateSlideWidths() {
//     slidesPerView = getSlidesPerView();
//     const slideWidth = track.clientWidth / slidesPerView;
//     slides.forEach(slide => {
//       slide.style.width = `${slideWidth - 20}px`;
//     });
//     updateSlidePosition();
//   }

//   function updateSlidePosition() {
//     const slideWidth = slides[0].clientWidth;
//     track.style.transform = `translateX(-${currentSlide * slideWidth}px)`;
//   }

//   nextButton.addEventListener('click', () => {
//     if (currentSlide < slides.length - slidesPerView) {
//       currentSlide++;
//       updateSlidePosition();
//     }
//   });

//   prevButton.addEventListener('click', () => {
//     if (currentSlide > 0) {
//       currentSlide--;
//       updateSlidePosition();
//     }
//   });

//   window.addEventListener('resize', updateSlideWidths);

//   updateSlideWidths();
// });

document.addEventListener('DOMContentLoaded', function() {

  const track = document.querySelector('.blog-slider-track');
  const slides = Array.from(document.querySelectorAll('.blog-slide'));
  const nextButton = document.querySelector('.blog-slider-button.next');
  const prevButton = document.querySelector('.blog-slider-button.prev');

  let currentSlide = 0;
  let slidesPerView = getSlidesPerView();

  let isDragging = false;
  let startX = 0;
  let currentTranslate = 0;
  let prevTranslate = 0;

  function getSlidesPerView() {
    const width = window.innerWidth;
    if (width >= 1024) return 4;
    if (width >= 768) return 2;
    return 2;
  }

  function updateSlideWidths() {
    slidesPerView = getSlidesPerView();
    const slideWidth = track.clientWidth / slidesPerView;

    slides.forEach(slide => {
      slide.style.width = `${slideWidth - 20}px`;
    });

    updateSlidePosition();
  }

  function updateSlidePosition() {
    const slideWidth = slides[0].clientWidth;
    track.style.transform = `translateX(-${currentSlide * slideWidth}px)`;
  }

  /* BUTTON CLICK */

  nextButton.addEventListener('click', () => {
    if (currentSlide < slides.length - slidesPerView) {
      currentSlide++;
      updateSlidePosition();
    }
  });

  prevButton.addEventListener('click', () => {
    if (currentSlide > 0) {
      currentSlide--;
      updateSlidePosition();
    }
  });

  /* DRAG WITH MOUSE */

  track.addEventListener('mousedown', startDrag);
  track.addEventListener('mousemove', dragMove);
  track.addEventListener('mouseup', endDrag);
  track.addEventListener('mouseleave', endDrag);

  /* TOUCH SWIPE MOBILE */

  track.addEventListener('touchstart', startDrag);
  track.addEventListener('touchmove', dragMove);
  track.addEventListener('touchend', endDrag);

  function startDrag(e) {
    isDragging = true;
    startX = getPositionX(e);
  }

  function dragMove(e) {
    if (!isDragging) return;

    const currentPosition = getPositionX(e);
    const diff = currentPosition - startX;

    if (diff > 50 && currentSlide > 0) {
      currentSlide--;
      updateSlidePosition();
      isDragging = false;
    }

    if (diff < -50 && currentSlide < slides.length - slidesPerView) {
      currentSlide++;
      updateSlidePosition();
      isDragging = false;
    }
  }

  function endDrag() {
    isDragging = false;
  }

  function getPositionX(e) {
    return e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
  }

  window.addEventListener('resize', updateSlideWidths);

  updateSlideWidths();

});
// blog-slider js end





// our-promise js start
document.addEventListener("DOMContentLoaded", function() {
  if (window.innerWidth < 768) {
    $('.our-promise-section .promise-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3
          }
        }
      ]
    });

  }
});
// our-promise js end



// custom-image-video-banner js
document.addEventListener("DOMContentLoaded", function () {
  const videos = document.querySelectorAll('.custom-image-video-banner video');

  videos.forEach(function(video) {
    // Required attributes for iOS
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.muted = true;
    video.autoplay = true;
    video.loop = true;

    // Force load & play
    video.load();

    const playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          // autoplay started
        })
        .catch(() => {
          // fallback: play on first user interaction
          const playOnClick = () => {
            video.play();
            document.removeEventListener('touchstart', playOnClick);
          };
          document.addEventListener('touchstart', playOnClick);
        });
    }
  });
});
// custom-image-video-banner js end




// product-slider-slick js
document.addEventListener("DOMContentLoaded", function () {
    $('.product-slider-slick').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: true,

      prevArrow: `<button class="slick-prev custom-arrow">
        <svg viewBox="0 0 100 100">
          <path d="M 10,50 L 60,100 L 70,90 L 30,50 L 70,10 L 60,0 Z"></path>
        </svg>
      </button>`,

      nextArrow: `<button class="slick-next custom-arrow">
        <svg viewBox="0 0 100 100">
          <path d="M 10,50 L 60,100 L 70,90 L 30,50 L 70,10 L 60,0 Z" transform="translate(100,100) rotate(180)"></path>
        </svg>
      </button>`,

      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            arrows: false
          }
        }
      ]
    });
});
// product-slider-slick js End